import React, { useState } from 'react';

export const CompleteModalContent = ({ onSubmit, onClose, loading }) => {
    // Fields: GiftCard_codes, order_message, expiry_date
    const [formData, setFormData] = useState({
        GiftCard_codes: '',
        order_message: '',
        expiry_date: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
                <label className="text-sm font-medium">Gift Card Codes</label>
                <input
                    type="text"
                    name="GiftCard_codes"
                    value={formData.GiftCard_codes}
                    onChange={handleChange}
                    className="border p-2 rounded text-sm"
                    placeholder="Enter codes"
                    required
                    disabled={loading}
                />
            </div>
            <div className="flex flex-col gap-1">
                <label className="text-sm font-medium">Order Message</label>
                <textarea
                    name="order_message"
                    value={formData.order_message}
                    onChange={handleChange}
                    className="border p-2 rounded text-sm"
                    placeholder="Enter message"
                    required
                    disabled={loading}
                />
            </div>
            <div className="flex flex-col gap-1">
                <label className="text-sm font-medium">Expiry Date</label>
                <input
                    type="text"
                    name="expiry_date"
                    value={formData.expiry_date}
                    onChange={handleChange}
                    className="border p-2 rounded text-sm"
                    placeholder="DD-MM-YYYY"
                    required
                    disabled={loading}
                />
                {/* Note: User example was 22-02-2026, could use type="date" but format might differ. keeping text for flexibility or date if preferred */}
            </div>

            <div className="flex justify-end gap-2 mt-4">
                <button
                    type="button"
                    onClick={onClose}
                    className="px-4 py-2 border rounded text-sm hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={loading}
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    className="px-4 py-2 bg-green-600 text-white rounded text-sm hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Submitting...
                        </>
                    ) : "Submit"}
                </button>
            </div>
        </form>
    );
};

export const CancelledModalContent = ({ onSubmit, onClose, loading }) => {
    // Fields: order_message, transaction_revert
    const [formData, setFormData] = useState({
        order_message: '',
        transaction_revert: true,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
                <label className="text-sm font-medium">Order Message</label>
                <textarea
                    name="order_message"
                    value={formData.order_message}
                    onChange={handleChange}
                    className="border p-2 rounded text-sm"
                    placeholder="Enter reason for cancellation"
                    required
                    disabled={loading}
                />
            </div>
            <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
                <input
                    type="checkbox"
                    id="transaction_revert"
                    name="transaction_revert"
                    checked={formData.transaction_revert}
                    onChange={handleChange}
                    className="rounded border-gray-300"
                    disabled={loading}
                />
                <label htmlFor="transaction_revert" className="text-sm">Revert Transaction</label>
            </div>

              {/* Warning message */}
                {!formData.transaction_revert && (
                    <div className="animate-pulse bg-yellow-300 text-black px-3 py-1 rounded text-sm">
                       <b> Please note:</b>  Points will not be reverted unless <b>"Revert Transaction" </b>  is selected.
                    </div>
                )}
            </div>

            <div className="flex justify-end gap-2 mt-4">
                <button
                    type="button"
                    onClick={onClose}
                    className="px-4 py-2 border rounded text-sm hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={loading}
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    className="px-4 py-2 bg-red-600 text-white rounded text-sm hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Submitting...
                        </>
                    ) : "Cancel Request"}
                </button>
            </div>
        </form>
    );
};
